document.addEventListener('DOMContentLoaded', function(){
  // Mobile menu / hamburger
  document.querySelectorAll('[data-menu-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){ document.documentElement.classList.toggle('menu-open'); });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function(b){ b.addEventListener('click', function(){ document.documentElement.classList.remove('menu-open'); }); });

  // Scroll reveal
  if (document.body.dataset.reveal === 'true' && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); } }); }, {threshold:0.08});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('is-visible'); }); }

  // Collapsible (accordion)
  document.querySelectorAll('[data-collapsible] .collapsible__q').forEach(function(q){
    q.addEventListener('click', function(){ q.closest('.collapsible__item').classList.toggle('open'); });
  });

  // Slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function(box){
    var slides=[].slice.call(box.querySelectorAll('.slide')); if(slides.length<2) return;
    var i=0, dur=parseInt(box.dataset.autoplay||'0',10), timer=null;
    var dots=box.querySelector('.slide-dots');
    slides.forEach(function(_,k){ if(dots){ var b=document.createElement('button'); if(k===0)b.className='on'; b.addEventListener('click',function(){show(k);start();}); dots.appendChild(b);} });
    function show(n){ i=(n+slides.length)%slides.length; slides.forEach(function(s,k){s.classList.toggle('on',k===i);}); if(dots){[].forEach.call(dots.children,function(d,k){d.className=k===i?'on':'';});} }
    function nx(){show(i+1);} function start(){stop(); if(dur>0)timer=setInterval(nx,dur);} function stop(){if(timer){clearInterval(timer);timer=null;}}
    var np=box.querySelector('[data-next]'), pv=box.querySelector('[data-prev]');
    if(np)np.addEventListener('click',function(){nx();start();}); if(pv)pv.addEventListener('click',function(){show(i-1);start();});
    box.addEventListener('mouseenter',stop); box.addEventListener('mouseleave',start); start();
  });

  // Quantity steppers + disable Add to Cart while quantity is 0
  document.querySelectorAll('[data-qty]').forEach(function(w){
    var inp=w.querySelector('input');
    var min=parseInt(inp.getAttribute('min')||'1',10);
    var form=w.closest('form');
    var addBtn=form ? form.querySelector('button[type="submit"]') : null;
    function syncBtn(){ if(addBtn && !addBtn.hasAttribute('data-soldout')){ addBtn.disabled = (parseInt(inp.value||'0',10) < 1); } }
    w.querySelectorAll('[data-step]').forEach(function(b){ b.addEventListener('click',function(){ var v=parseInt(inp.value||(''+min),10)+parseInt(b.dataset.step,10); if(v<min)v=min; inp.value=v; syncBtn(); }); });
    inp.addEventListener('change',syncBtn); inp.addEventListener('input',syncBtn);
    syncBtn();
  });

  // Product gallery thumbs
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var badge=g.querySelector('.gallery-badge');
    g.querySelectorAll('[data-thumb]').forEach(function(t){ t.addEventListener('click', function(){
      var idx=t.dataset.thumb; g.querySelectorAll('[data-main-img]').forEach(function(m){ m.classList.toggle('active', m.dataset.mainImg===idx); });
      g.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.remove('active'); }); t.classList.add('active');
      if(badge) badge.style.display = (idx==='0') ? '' : 'none';
    }); });
  });
});

/* Variant picker (main-product) */
(function(){
  var form = document.querySelector('[data-variants]');
  if(!form) return;
  var variants; try { variants = JSON.parse(form.textContent); } catch(e){ return; }
  var pdp = document.querySelector('.pdp');
  if(!pdp) return;
  var selected = {};
  pdp.querySelectorAll('.variant-value.is-active').forEach(function(b){
    var idx = b.closest('.variant-values').getAttribute('data-option-index');
    selected[idx] = b.getAttribute('data-value');
  });
  function currentOptions(){
    var groups = pdp.querySelectorAll('.variant-values');
    var opts = [];
    groups.forEach(function(g){ opts[+g.getAttribute('data-option-index')] = selected[g.getAttribute('data-option-index')]; });
    return opts;
  }
  function findVariant(){
    var opts = currentOptions();
    return variants.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); });
  }
  function update(){
    var v = findVariant();
    var idInput = pdp.querySelector('[data-variant-id]');
    var addBtn = pdp.querySelector('[data-add-btn]');
    var priceEl = pdp.querySelector('.pdp__price');
    if(v){
      if(idInput) idInput.value = v.id;
      if(addBtn){ addBtn.disabled = !v.available; addBtn.textContent = v.available ? (addBtn.getAttribute('data-label')||addBtn.textContent) : 'Sold out'; }
      if(v.available && addBtn && addBtn.dataset.default){ addBtn.textContent = addBtn.dataset.default; }
      if(priceEl){
        var html = '';
        if(v.compare_at_price && v.compare_at_price > v.price){
          html = '<span class="price price--sale">'+ Shopify.formatMoney(v.price) +'</span> <s class="price--compare">'+ Shopify.formatMoney(v.compare_at_price) +'</s>';
        } else {
          html = '<span class="price">'+ Shopify.formatMoney(v.price) +'</span>';
        }
        if(window.Shopify && Shopify.formatMoney) priceEl.innerHTML = html;
      }
    } else if(addBtn){ addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
  }
  pdp.querySelectorAll('.variant-value').forEach(function(btn){
    if(!btn.dataset.default) {}
    btn.addEventListener('click', function(){
      var group = btn.closest('.variant-values');
      group.querySelectorAll('.variant-value').forEach(function(b){ b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected[group.getAttribute('data-option-index')] = btn.getAttribute('data-value');
      update();
    });
  });
  var addBtn = pdp.querySelector('[data-add-btn]');
  if(addBtn) addBtn.dataset.default = addBtn.textContent.trim();
})();

/* Minimal money formatter fallback */
window.Shopify = window.Shopify || {};
if(!Shopify.formatMoney){
  Shopify.moneyFormat = window.__moneyFormat || '${{amount}}';
  Shopify.formatMoney = function(cents){
    if(typeof cents === 'string') cents = cents.replace('.','');
    var value = (cents/100).toFixed(2);
    return Shopify.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value);
  };
}
